import TemplateKeywordDefault from "@pages/Keyword/templates/TemplateKeywordDefault/TemplateKeywordDefault";
import TemplateWithHighlights from "@pages/Keyword/templates/TemplateWithHighlights/TemplateWithHighlights";

export const KeywordTemplateFactory = (template: string) => {
  switch (template) {
    case "withHighlight":
      return TemplateWithHighlights;

    default:
      return TemplateKeywordDefault;
  }
};
